import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for /library. The list lives in library.index.tsx and the item
// detail in library.$id.tsx; both render through this Outlet. Without an Outlet
// here, navigating to /library/$id would match the nested detail route but still
// render only this parent — showing the library list again.
export const Route = createFileRoute("/library")({
  component: LibraryLayout,
});

function LibraryLayout() {
  return <Outlet />;
}
